import { FlashCardsDeckCollection } from '@containers/FlashCardsDeckCollection';

export function Decks() {
  return <FlashCardsDeckCollection />;
}
